import { render } from "./pickup-location.vue?vue&type=template&id=7247545c"
import script from "./pickup-location.vue?vue&type=script&lang=js"
export * from "./pickup-location.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__